<script setup>

import {onMounted, onUnmounted, reactive, watch} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";

const compName = 'UnassignedClaimsComponent';

const props = defineProps({
  clientId: null
});

onMounted(() => {
  getData();

  activeComponentStore.registerComponent(
      compName,
      [
        'claims'
      ],
      getData
  );
});

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});

const data = reactive({
  headers: [
    {title: 'Claim Number', key: 'claimnumber'},
    {title: 'Client', key: 'name'},
    {title: 'Claim Type', key: 'type'},
    {title: 'Cat Code', key: 'cat',},
    {title: 'Insured Person', key: 'insuredname'},
    {title: 'Age (Days)', key: 'age'},
  ],
  search: null,
  dataLoading: true,
  newAdj: false,
  items: []
});

watch(() => props.clientId, async (val) => {
  getData();
});

const GetIsFireType = (claim) => {
  if(claim.type) {
    return claim.type.toString().toLowerCase().includes('fire');
  }
  return false;
}

const getData = () => {
  data.loading = true;
  data.dataLoading = true;

  ApiWrapper.post('claims','unassigned-claims', {
    clientId: props.clientId
  })
      .then((response) => {
        data.items = response.claims;

        for (let x in data.items) {
          if (data.items[x].type) {
            data.items[x].type = data.items[x].type.replace(/[[\]&]+/g, '');
          }
        }

        data.dataLoading = false
      })
      .catch((error) => {
        ToastUtil.error(error);
        data.loading = false;
      })
}

</script>

<template>
  <v-container id="entreos-resize-target" fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Unassigned Claims</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="4">
          <v-text-field
              v-model="data.search"
              append-inner-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="ml-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          item-value="claimid"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{item.claimnumber}}
          </RouterLink>
          <span class="ma-0 ml-3" v-if="GetIsFireType(item)"> <v-icon color="orange">mdi-fire-circle</v-icon> </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>